<div class="custom-modal-container">
  <div class="modal-header">
    <h3 class="modal-title">Platform Upgrade Ready – Build {{ args.version }}</h3>
    <button class="modal-close" aria-label="Close dialog" (click)="onCancel()">×</button>
  </div>
  <div class="modal-body">
    Avion Service Desk has evolved. Refreshing to sync you with the next-generation experience.
  </div>

  <div class="modal-footer">
    <button type="button"
            (click)="onCancel()"
            class="card-action cancel-action">
      Cancel
    </button>

    <button type="button"
            class="card-action primary-action"
            (click)="confirm()">Confirm
    </button>
  </div>
</div>
